import { enumSectionFromUIMode, enumUIModes, UItoHLConversion } from "../constants";
import { Globals } from "./Globals";

export class QHotLinkObj {
  constructor() {
    this.fHotLinkSection = null;
    this.fHotLinkMode = null;
    this.fPaneltoUpdate = null;
    this.fWSMgr = null;
    this.fData = {};
  }

  ValidateModeAndSection(section, mode) {
    const gUIConfig = Globals._uiConfig;
    var UIMode = gUIConfig.GetUIMode();
    switch (UIMode) {
      case enumUIModes.edit:
        if (UItoHLConversion[UIMode]["invalid"].includes(mode)) {
          this.SetHotLinkPanelMode(UItoHLConversion[UIMode]["valid"]);
          this.SetHotLinkPanelSection(enumSectionFromUIMode[this.GetHotLinkPanelMode()][section]);
          break;
        }
      default:
        this.SetHotLinkPanelSection(section);
        this.SetHotLinkPanelMode(mode);
        break;
    }
  }

  SetShouldShowHL() {
    const gUIConfig = Globals._uiConfig;
    var UIMode = gUIConfig.GetUIMode();
    switch (UIMode) {
      case enumUIModes.edit:
        if (this.GetHotLinkPanelSection() == "Profile" && this.fPaneltoUpdate != null)
          this.fPaneltoUpdate.fHasHotLink = false;
        break;
      default:
        break;
    }
  }

  InitHotLinkObj(section, panel, wsMgr, mode) {
    this.fPaneltoUpdate = panel;
    this.ValidateModeAndSection(section, mode);
    this.SetShouldShowHL();
    this.fWSMgr = wsMgr;
  }

  AddData(key, value) {
    this.fData[key] = value;
  }

  GetData(key) {
    if (key) return this.fData[key];
    else return this.fData;
  }

  GetHotLinkPanelMode() {
    return this.fHotLinkMode;
  }

  SetHotLinkPanelMode(mode) {
    this.fHotLinkMode = mode;
  }

  GetHotLinkPanelTarget() {
    return this.fPaneltoUpdate;
  }

  GetHotLinkPanelSection() {
    return this.fHotLinkSection;
  }

  SetHotLinkPanelSection(section) {
    if (section != null) this.fHotLinkSection = section;
    else if (this.fPaneltoUpdate != null) this.fPaneltoUpdate.fHasHotLink = false;
  }
}
